'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDecorator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _children = require('./children');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createDecorator(Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Decorator(children, maybeComponent, maybeContext) {
    return maybeContext ? _react2.default.createElement(Component, props, (0, _children.createChildren)(children, maybeComponent)) : Decorator.bind(null, [].concat(children, maybeComponent || []));
  };
}